import { useMemo } from "react";
import { useLocation } from "react-router";
import { NavigationSource } from "../../common/enums/NavigationSource";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { getRouteContext } from "./UseRouteContextUtils";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { getViewIDFromPath } from "../../common/utilities/RouteHelpers";

export type RouteContextStateType = {
    // [key: string]: number | string | undefined;
    configurationID?: number | undefined;
};

export type RouteContextType = {
    //[index: string]: undefined | null | string | number | boolean | NavigationSource | IeLynxObject;// | RouteContextState;

    organizationID?: number | undefined;
    groupID?: number | undefined;
    tankBatteryID?: number | undefined;
    wellID?: number | undefined;
    deviceID?: number | undefined;
    tankID?: number | undefined;
    tagID?: number | undefined;
    //configurationID?: number | undefined;
    siteID?: number | undefined;
    typeID?: number | undefined;
    newUser?: boolean | undefined;
    restoreState?: boolean | undefined;
    navSrc?: NavigationSource | undefined;
    token?: string | null | undefined;
    contextObject?: IeLynxObject | undefined;
    viewID: UIViewEnum | undefined;
    
    state?: RouteContextStateType | undefined;
};

export function useRouteContext(debugID?: string): RouteContextType {
    const location = useLocation();
    const viewID = getViewIDFromPath(location.pathname, UIViewEnum.None);

    const routeContext = useMemo(
        () => {
            if(debugID){
                console.log(`#### Creating new route context for debugID=${debugID} => ${JSON.stringify(location.state)}`)
            }
        
            return getRouteContext(viewID, location.search, location.state as RouteContextStateType);
        },
        [viewID, location.search, location.state, debugID]
    );

    return routeContext;
}
